<template>
  <div class="answer-sheet-box">
    <button @click="beginSheethandle()" >开始测试</button>
  </div>
</template>

<script>
export default {
    data(){
        return{

        }
    },
    methods:{
        beginSheethandle(){
            this.$emit("answerBoolhandle",false);
        }
    }
}
</script>

<style lang="scss">
body{
    background: #ffffff;
}
.answer-sheet-box{
    background-image: url(../../../assets/measurement/answer_sheet_bg.png);
    background-size: cover;
    width: 100%;
    max-width: 750px;
    height: 100%;
    box-sizing: border-box;
    background-color: #ffffff;
    text-align: center;
    margin: 0;
    padding: 0;
    button{
        position: absolute;
        z-index: 2;
        width: 470px;
        line-height: 64px;
        height: 80px;
        background-color: #E60012;
        color: #ffffff;
        border: 0;
        border-radius: 40px;
        font-size: 30px;
        bottom: 90px;
        left: 50%;
        transform: translateX(-50%);
    }
}
</style>